// Client for the inline `report:` problem-report flow. When Emil's composer
// message starts with `report:` (parseReportPrefix in src/lib/parse.ts), the
// composer calls this INSTEAD of dispatchEricStream — the message is diverted to
// POST /api/reports and never reaches Eric. The response carries the persisted
// `report` transcript row (shaped like any thread message) so the composer can
// render it through rowToVM, identical to a reload.

import { authFetch } from '@/lib/api'
import type { ThreadMessageRow } from '@/lib/threads'

type GetToken = () => Promise<string | null>

// The turn the report is about — exactly what was on Emil's screen when he typed
// `report:`. The worker falls back to the user's most recent Eric turn when the
// client doesn't supply one (e.g. a fresh chat).
export type ReportAnchor = {
  request_id: string | null
  user_message: string | null
  eric_reply: string | null
}

export type SubmitReportResult = {
  ok: boolean
  id: string
  message: ThreadMessageRow | null
}

export function submitReport(
  getToken: GetToken,
  input: {
    text: string
    threadId?: string | null
    surface?: string
    anchor?: ReportAnchor | null
  },
): Promise<SubmitReportResult> {
  return authFetch<SubmitReportResult>('/api/reports', getToken, {
    method: 'POST',
    body: JSON.stringify({
      text: input.text,
      ...(input.threadId ? { thread_id: input.threadId } : {}),
      surface: input.surface ?? 'thread',
      ...(input.anchor ? { anchor: input.anchor } : {}),
    }),
  })
}
